import React, {Component} from 'react';
import * as firebase from 'firebase';
import 'firebase/firestore';
import mapboxgl from 'mapbox-gl'
import {MenuOutlined, QuestionCircleOutlined} from '@ant-design/icons';
import {
    Drawer,
    Button,
    Select,
    Modal,
    List,
    Form,
    Input,
    Spin,
    Radio,
    notification,
    message,
    Tag
} from 'antd';
import {EditShopModalForm} from "./modal/editShop";
import {CreateShopModalForm} from "./modal/createShop";
import {InfoPopup} from "./modal/infoPopup";
import {localization} from './Localization'
import shortid from 'shortid'
import PLACES from './places.json';
import './App.css';
import {
    editDataByID,
    isAuthenticated,
    loginWithEmail,
    logout,
    getAllData,
    createNewData,
    parseGeoPoint,
    getDataByID,
    findShopNearMe,
    uploadPic,
    sendAnalyze
} from './firebase'
import geohash from 'ngeohash';
import axios from 'axios';

const {Option} = Select;
const {Search} = Input;

var db = firebase.firestore()
const mbToken = `pk.eyJ1IjoiZWdneW80ODU5IiwiYSI6ImNpb2wzaHFkYTAwM291MG0wNWZ4cW5sMGcifQ.yVv_6LIdOz8bp5ky9YDAtw`
mapboxgl.accessToken = mbToken
const legendConfig = {
    message: 'ความหมายสัญลักษณ์',
    description: (
        <div style={{
            textAlign: 'center'
        }}>
            <img src="./map-legend.png"/>
            <p style={{
                fontSize: 12
            }}>ตัวเลขในไอคอน คือ จำนวนเตียงว่าง</p>
        </div>
    ),
    placement: 'bottomLeft',
    style: {
        width: 200,
        marginLeft: -16
    }
};

export default class App extends Component {
    mapRef = React.createRef();
    map;
    centerMarker;
    unsubscribe;

    constructor(props, context) {
        super(props, context)
        this.state = {
            isFindBtnLoading: false,
            isMainLoad: true,
            isDrawerVisible: false,
            isCreateModalVisible: false,
            isEditModalVisible: false,
            isInfoModalVisible: false,
            isEditLoading: false,
            isAuth: true,
            currentUser: null,
            isAnonymousMode: true,
            markerGeoPoint: null,
            myData: [],
            selectedMarker: null,
            data: null,
            language: 'th',
            imageUploadUrl: '',
            isUploadWaiting: false,
            dataFilterType: null,
            isLoginModalVisible: false
        }
    }
    componentDidMount = async() => {
        this.checkAuthenticate()
        sendAnalyze('open_app')
    }
    checkAuthenticate = async() => {
        const res = await isAuthenticated()
        this.initMap()
        this.makeCenterMarker()
        if (res.user) {
            this.setState({
                isAuth: true,
                currentUser: res.user,
                isMainLoad: false
            }, () => {
                this.listenData(res.user.uid)
                this.addMarkerCenter()
                notification.open(legendConfig);
            })
        } else {
            this.listenData()
            this.setState({isAuth: false, isMainLoad: false})
            notification.open(legendConfig);
        }
    }
    listenData = async(uid) => {
        const that = this
        var query = db.collection("data")
        if (uid) {
            query = query.where('owner', '==', uid)
        }
        if (this.state.dataFilterType || this.state.dataFilterType === 0) {
            query = query.where('type', '==', this.state.dataFilterType)
        }
        this.unsubscribe = query.onSnapshot(async function (snapshot) {
            that.getMyData(uid)
            snapshot
                .docChanges()
                .forEach(function (change) {
                    const data = change
                        .doc
                        .data();
                    if (change.type === "added") {
                        new mapboxgl
                            .Marker(that.renderMarkerDOM(data))
                            .setLngLat([data.geo.V, data.geo.F])
                            .addTo(that.map);
                    }
                    if (change.type === "modified") {
                        const element = document.getElementById(data.id)
                        element
                            .parentNode
                            .removeChild(element);
                        new mapboxgl
                            .Marker(that.renderMarkerDOM(data))
                            .setLngLat([data.geo.V, data.geo.F])
                            .addTo(that.map);
                    }
                    if (change.type === "removed") {
                        const element = document.getElementById(data.id)
                        element
                            .parentNode
                            .removeChild(element);
                    }
                });
        });
    }
    handleUploadChange = async info => {
        if (info.file.status === 'uploading') {
            this.setState({isUploadWaiting: true});
            return;
        }
        if (info.file.status === 'done') {
            const res = await uploadPic(info)
            if (res.type === 'success') {
                this.setState({imageUploadUrl: res.data, isUploadWaiting: false})
            }
        }
    };
    getMyData = async(uid) => {
        const res = await getAllData(uid)
        if (res.type === 'success') {
            this.setState({myData: res.results})
        } else {
            this.showMessage(res.type, res.msg)
        }
    }
    clearAllMarker = () => {
        var paras = document.getElementsByClassName('data-marker');
        while (paras[0]) {
            paras[0]
                .parentNode
                .removeChild(paras[0]);
        }
    }
    renderMarkerDOM = (data) => {
        const that = this
        var el = document.createElement('div');
        el.id = data.id
        el.className = 'data-marker';
        el.style.backgroundColor = colorByLevel(data.available)
        var fontSize = 14
        var marginTop = 3
        if (`${data.available}`.length >= 3) {
            fontSize = 12
            marginTop = 4
        }
        el.innerHTML = `
        <div style='width:100%;color:black;font-weight:bold;font-size:13px;margin-top:-20px;background-color:white;'>${shortNameByType(data.type)}</div>
        <p style='width:100%;color:white;font-weight:bold;font-size:${fontSize}px;margin-top:${marginTop}px'>${data.available}</p>`

        el.addEventListener('click', function () {
            that.setState({
                selectedMarker: data
            }, () => {
                that.showModal('info');
            });
        });
        return el
    }

    initMap = () => {
        this.map = new mapboxgl.Map({
            container: this.mapRef.current,
            style: 'https://v2k.vallarismaps.com/core/api/1.0-beta/styles/610e89f25b11251feaa5705c?api_key=CfIJL0i6WOdiR9z14Ox8y2MX58BTfGj6e1jrhDYmJuaz2XqzvW9GaROEf7mKRr2k',
            center: [
                100.523186, 13.736717
            ],
            zoom: 6
        });
        const onMoveEnd = () => {
            const center = this
                .map
                .getCenter();
            this
                .centerMarker
                .setLngLat([center.lng, center.lat]);
            this.setState({markerGeoPoint: center});
        }
        this
            .map
            .on('move', onMoveEnd);
        this
            .map
            .addControl(new mapboxgl.GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
            }));
    }

    makeCenterMarker = () => {
        const center = this
            .map
            .getCenter()
        this.centerMarker = new mapboxgl
            .Marker({draggable: false})
            .setLngLat([center.lng, center.lat])
        const onDragEnd = () => {
            var lngLat = this
                .centerMarker
                .getLngLat();
            this.setState({markerGeoPoint: lngLat});
        }
        this
            .centerMarker
            .on('dragend', onDragEnd);
    }
    addMarkerCenter() {
        const center = this
            .map
            .getCenter();
        this
            .centerMarker
            .setLngLat([center.lng, center.lat])
            .addTo(this.map);
    }
    removeMarkerCenter() {
        this
            .centerMarker
            .remove();
    }

    showMessage = (type, msg) => {
        if (type === 'success') {
            message.success(msg)
        } else if (type === 'error') {
            message.error(msg)
        } else {
            message.warning(msg)
        }
    }
    flyToId = async(id) => {
        const res = await getDataByID(id)
        if (res.data) {
            this
                .map
                .flyTo({
                    center: [
                        res.data.geo.V, res.data.geo.F
                    ],
                    essential: true,
                    zoom: 12
                });
        }
    }
    flyToLocation = async(center) => {
        this
                .map
                .flyTo({
                    center: center,
                    essential: true,
                    zoom: 12
                });
    }

    onShowDrawer = () => {
        this.setState({isDrawerVisible: true});
    };
    onDrawerClose = () => {
        this.setState({isDrawerVisible: false});
    };
    onSearchChange = (value) => {
        this.onDrawerClose()
        this.flyToId(value)
    }
    showModal = (type) => {
        if (type === 'create') {
            this.setState({isCreateModalVisible: true});
        } else if (type === 'edit') {
            this.setState({isEditModalVisible: true});
            sendAnalyze('open_edit')
        } else {
            this.setState({isInfoModalVisible: true})
            sendAnalyze('open_info')
        }
    };

    handleEditModalOk = async(e) => {
        e.updatedAt = new Date().getTime()
        e.capacity = parseInt(e.capacity)
        e.available = parseFloat(e.available)
        e.detail = e.detail || '-'
        if (e.lat) {
            e.geo = parseGeoPoint({
                lat: parseFloat(e.lat),
                lng: parseFloat(e.lng)
            })
            e.geoHash = geohash.encode(e.lat, e.lng)
        }
        const res = await editDataByID(e)
        this.showMessage(res.type, res.msg)
        this.setState({isEditModalVisible: false, imageUploadUrl: ''});
        sendAnalyze('edited_data')
    };

    handleCreateModalOk = async(e) => {
        e.createdAt = new Date().getTime()
        e.updatedAt = new Date().getTime()
        e.owner = this.state.currentUser.uid
        e.id = shortid.generate()
        e.geo = parseGeoPoint(this.state.markerGeoPoint)
        e.geoHash = geohash.encode(this.state.markerGeoPoint.lat, this.state.markerGeoPoint.lng)
        e.capacity = parseInt(e.capacity)
        e.available = parseFloat(e.available)
        e.detail = e.detail || '-'
        const res = await createNewData(e)
        this.showMessage(res.type, res.msg)
        this.setState({isCreateModalVisible: false, imageUploadUrl: ''});
        sendAnalyze('created_data')
    };

    handleModalCancel = (type) => {
        if (type === 'create') {
            this.setState({isCreateModalVisible: false});
        } else if (type === 'edit') {
            this.setState({isEditModalVisible: false});
        } else {
            this.setState({isInfoModalVisible: false})
        }
    };
    onLanguageChange = e => {
        console.log('radio checked', e.target.value);
        this.setState({language: e.target.value});
        sendAnalyze('change_language')
    };
    handleLogout = async() => {
        const res = await logout()
        if (res.type === 'success') {
            this.setState({
                currentUser: null,
                isAuth: false
            }, () => {
                this.anonymousMode();
            })
        }
        this.showMessage(res.type, res.msg)
    }

    editorMode = async() => {
        this.setState({isAnonymousMode: false, myData: []})
        this.clearAllMarker()
        this.addMarkerCenter()
        this.unsubscribe()
        this.listenData(this.state.currentUser.uid)
    }
    anonymousMode = async() => {
        this.setState({isAnonymousMode: true, myData: []})
        this.clearAllMarker()
        this.removeMarkerCenter()
        this.unsubscribe()
        this.listenData()
    }

    handleGoogleMap = () => {
        const {selectedMarker} = this.state
        window.open(`https://maps.google.com/?q=${selectedMarker
            ? selectedMarker.geo.F + ',' + selectedMarker.geo.V
            : ''}`, '_blank')
        sendAnalyze('press_google');
    }

    handleCall = () => {
        const {selectedMarker} = this.state
        window.location.href = `tel:${selectedMarker
            ? selectedMarker.phone
            : ''}`;
        sendAnalyze('press_call');
    }

    handleDataTypeChange = (value) => {
        this.setState({
            dataFilterType: value
        }, () => {
            this.anonymousMode()
        })
    }
    onSearch = async(v) => {
        const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${v}.json?access_token=${mbToken}`
        const res = await axios.get(url);
        console.log('res',res.data);
        if(res.data.features.length > 0){
            const {center} = res.data.features[0]
            console.log('center',center);
            this.flyToLocation(center)
        }else{
            this.showMessage('error','not found place');
        }
    }
    onLoginFormFinish = async(values) => {
        const res = await loginWithEmail(values.username, values.password);
        if (res.user) {
            this.setState({
                currentUser: res.user,
                isAuth: true,
                isLoginModalVisible: false
            }, () => {
                this.editorMode();
            });
        }
        this.showMessage(res.type, res.msg);
    }
    onLoginFormFinishFailed = async(errorInfo) => {
        console.log('Failed:', errorInfo);
        this.showMessage('error', errorInfo)
    }

    renderLoginForm = () => {
        const {isLoginModalVisible} = this.state
        return (
            <Modal
                title="Log in"
                visible={isLoginModalVisible}
                footer={null}
                onCancel={() => {
                this.setState({isLoginModalVisible: false});
            }}>
                <Form
                    name="basic"
                    labelCol={{
                    span: 6
                }}
                    wrapperCol={{
                    span: 14
                }}
                    onFinish={this.onLoginFormFinish}
                    onFinishFailed={this.onLoginFormFinishFailed}>
                    <Form.Item
                        label="Username"
                        name="username"
                        rules={[{
                            required: true,
                            message: 'Please input your username!'
                        }
                    ]}>
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{
                            required: true,
                            message: 'Please input your password!'
                        }
                    ]}>
                        <Input.Password/>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                        offset: 9,
                        span: 16
                    }}>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }

    renderEditShopModal() {
        return (<EditShopModalForm
            visible={this.state.isEditModalVisible}
            data={this.state.data}
            language={this.state.language}
            onSubmit={this.handleEditModalOk}
            onCancel={this.handleModalCancel}
            imageUploadUrl={this.state.imageUploadUrl}
            onUpload={this.handleUploadChange}
            isUploadWaiting={this.state.isUploadWaiting}/>)
    }

    renderInfoPopupModal() {
        return (<InfoPopup
            visible={this.state.isInfoModalVisible}
            data={this.state.selectedMarker}
            language={this.state.language}
            onGoogleMap={this.handleGoogleMap}
            onCall={this.handleCall}
            onCancel={this.handleModalCancel}
            user={this.state.currentUser}/>)
    }

    renderCreateShopModal() {
        return (<CreateShopModalForm
            visible={this.state.isCreateModalVisible}
            language={this.state.language}
            onSubmit={this.handleCreateModalOk}
            onCancel={this.handleModalCancel}
            imageUploadUrl={this.state.imageUploadUrl}
            onUpload={this.handleUploadChange}
            isUploadWaiting={this.state.isUploadWaiting}/>)
    }
    renderClientDrawer() {
        const {language, myData} = this.state
        const capacityReducer = (acc, item) => acc + item.capacity
        const availableReducer = (acc, item) => acc + item.available
        const hospitalKeys = [
            'normalHospital',
            'militaryHospital',
            'fieldHospital',
            'ci',
            'hi',
            'hospitel'
        ]
        let hospitals = []
        let hospitalsCapacity = []
        let hospitalsAvailable = []
        for (let index = 0; index <= 5; index++) {
            const hospital = myData.filter(item => item.type === index)
            const hospitalCapacity = hospital.reduce(capacityReducer, 0)
            const hospitalAvailable = hospital.reduce(availableReducer, 0)
            hospitals[index] = hospital
            hospitalsCapacity[index] = hospitalCapacity
            hospitalsAvailable[index] = hospitalAvailable
        }

        return (
            <Drawer
                title={`${localization()[language].findHeader}`}
                placement='left'
                width={280}
                closable={false}
                onClose={this.onDrawerClose}
                visible={this.state.isDrawerVisible}
                footer={(
                <div style={{
                    textAlign: 'center'
                }}>
                    {this.state.isAuth
                        ? (
                            <Button
                                block
                                type="primary"
                                onClick={() => {
                                this.editorMode()
                            }}>โหมดแก้ไขข้อมูล</Button>
                        )
                        : (
                            <div>
                                <p
                                    style={{
                                    fontSize: 13
                                }}>{localization()[language].menuLoginFooterString}</p>
                                <Button
                                    block
                                    type="primary"
                                    onClick={() => {
                                    this.setState({isLoginModalVisible: true});
                                }}>Log in</Button>
                            </div>
                        )}
                </div>
            )}>
                <Select
                    onChange={this.handleDataTypeChange}
                    style={{
                    width: '100%',
                    marginBottom: 12
                }}
                    defaultValue={null}>
                    <Option value={null}>All</Option>
                    <Option value={0}>{localization()[language].normalHospital}</Option>
                    <Option value={1}>{localization()[language].militaryHospital}</Option>
                    <Option value={2}>{localization()[language].fieldHospital}</Option>
                    <Option value={3}>{localization()[language].ci}</Option>
                    <Option value={4}>{localization()[language].hi}</Option>
                    <Option value={5}>{localization()[language].hospitel}</Option>
                </Select>
                <Select
                    showSearch
                    style={{
                    width: '100%',
                    marginBottom: 30
                }}
                    placeholder={localization()[language].findInputPlaceHolder}
                    optionFilterProp="children"
                    onChange={this.onSearchChange}
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {this
                        .state
                        .myData
                        .map((data) => {
                            return (
                                <Option value={data.id}>{data.name}</Option>
                            )
                        })}
                </Select>
                <div>
                    <p style={{
                        fontWeight: 'bold'
                    }}>{localization()[language].statInfo}</p>
                    {hospitalKeys.map((item, index) => {
                        return (
                            <div
                                style={{
                                marginBottom: 8
                            }}>
                                <div>{`${localization()[language][item]} (${hospitals[index].length})`}</div>
                                <span>
                                    {localization()[language].availableBed}<Tag
                                        style={{
                                marginLeft: 4,
                                marginRight: 8
                            }}
                                        color={colorByLevel(hospitalsAvailable[index] * 100 / hospitalsCapacity[index])}>{hospitalsAvailable[index]}</Tag>
                                    {'/'}<Tag
                                        style={{
                                marginLeft: 8
                            }}
                                        color="#484C7F">{hospitalsCapacity[index]}</Tag>
                                </span>
                            </div>
                        )
                    })}
                </div>
            </Drawer>
        )
    }

    renderAdminDrawer() {
        const {language} = this.state
        return (
            <Drawer
                title={localization()[language].myDataHeader}
                placement='left'
                width={280}
                closable={false}
                onClose={this.onDrawerClose}
                visible={this.state.isDrawerVisible}
                footer={(
                <div style={{
                    textAlign: 'center'
                }}>
                    <Button
                        block
                        type="primary"
                        onClick={() => {
                        this.anonymousMode()
                    }}>{localization()[language].anonymousMode}</Button>
                    <Button
                        block
                        onClick={this.handleLogout}
                        style={{
                        marginTop: 12
                    }}>Log out</Button>
                </div>
            )}>
                <List
                    size="small"
                    dataSource={this.state.myData}
                    renderItem={item => <List.Item>
                    <a
                        href="#"
                        onClick={() => {
                        item.lat = item.geo.F;
                        item.lng = item.geo.V;
                        this.setState({
                            data: item
                        }, () => {
                            console.log(`this.state.data:${JSON.stringify(this.state.data)}`);
                            this.showModal('edit');
                            this.onDrawerClose();
                        })
                    }}>{item.name}</a>
                </List.Item>}/>
            </Drawer>
        )
    }

    getUserLocation = async() => {
        sendAnalyze('press_find');
        if (navigator.geolocation) {
            this.setState({isFindBtnLoading: true})
            navigator
                .geolocation
                .getCurrentPosition(async(position, error) => {
                    console.log(position.coords.latitude, position.coords.longitude);
                    if (position.coords.latitude) {
                        const res = await findShopNearMe(position.coords.latitude, position.coords.longitude)
                        if (res.type === 'success') {
                            this.setState({isFindBtnLoading: false})
                            const shopId = res.results.id
                            this.flyToId(shopId)
                        } else {
                            this.setState({isFindBtnLoading: false})
                            message.error(res.msg)
                        }
                        console.log(`Near me : ${JSON.stringify(res)}`);
                    } else {
                        this.setState({isFindBtnLoading: false})
                        message.error('กรุณากดปุ่มหาตำแหน่งของคุณ ด้าน ขวาบน');
                    }

                });
        } else {
            message.error('Web Browser นี้ไม่รองรับการค้นหาตำแหน่ง')
        }
    }
    renderFindNearBtn() {
        const {language} = this.state
        return (
            <Button
                className="shadow-darken25"
                style={{
                textAlign: 'center'
            }}
                loading={this.state.isFindBtnLoading}
                shape="round"
                size="large"
                onClick={() => {
                console.log('test');
                this.getUserLocation()
            }}>{localization()[language].findButton}</Button>
        )
    }
    renderCreateBtn() {
        const {language} = this.state
        return (
            <Button
                className="shadow-darken25"
                style={{
                textAlign: 'center'
            }}
                shape="round"
                size="large"
                onClick={() => {
                console.log('test');
                this.showModal('create')
            }}>{localization()[language].pinButton}</Button>
        )
    }

    render() {
        return (
            <div>
                <div ref={this.mapRef} className="absolute top right left bottom"/> {this.state.isMainLoad
                    ? (
                        <div
                            style={{
                            textAlign: 'center',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)'
                        }}>
                            <Spin size="large"/>
                        </div>
                    )
                    : (
                        <div>
                            {this.renderCreateShopModal()}
                            {this.renderLoginForm()}
                            {this.renderEditShopModal()}
                            {this.renderInfoPopupModal()}
                            <div
                                className="absolute top left ml12 mt12 border border--2 border--white bg-white shadow-darken25 z1 round">
                                <Button
                                    type="link"
                                    style={{
                                    width: 36,
                                    height: 28,
                                    textAlign: 'center'
                                }}
                                    icon={(<MenuOutlined/>)}
                                    onClick={() => {
                                    console.log('test');
                                    this.onShowDrawer()
                                }}></Button>
                            </div>
                            {!this.state.isAnonymousMode
                                ? (
                                    <div
                                        className="absolute top left ml60 mt12 border border--2 border--white bg-white shadow-darken25 z1 round">
                                        <Search
                                            placeholder="Long,Lat or Place Name"
                                            onSearch={this.onSearch}
                                            style={{
                                            width: 160
                                        }}/>
                                    </div>
                                )
                                : null}

                            <div
                                className="absolute top right mr60 mt12 border border--2 border--white bg-white shadow-darken25 z1 round">
                                <Radio.Group
                                    onChange={this.onLanguageChange}
                                    value={this.state.language}
                                    size="small">
                                    <Radio.Button value="th">TH</Radio.Button>
                                    <Radio.Button value="en">EN</Radio.Button>
                                </Radio.Group>

                            </div>
                            <div className="absolute bottom left ml6 mb36 shadow-darken25 z1 round-full">
                                <Button
                                    icon={(<QuestionCircleOutlined/>)}
                                    shape="circle"
                                    onClick={() => {
                                    legendConfig.duration = 0;
                                    notification.open(legendConfig);
                                    sendAnalyze('press_legend')
                                }}></Button>
                            </div>
                            <div className="absolute bottom right left align-center mb18">
                                {this.state.isAuth && !this.state.isAnonymousMode
                                    ? this.renderCreateBtn()
                                    : this.renderFindNearBtn()}
                            </div>
                            {this.state.isAuth && !this.state.isAnonymousMode
                                ? this.renderAdminDrawer()
                                : this.renderClientDrawer()}
                        </div>
                    )}
            </div>
        )
    }
}

const colorByLevel = (quantity) => {
    var color = '#262626'
    if (quantity > 0 && quantity <= 5) {
        color = '#851d41'
    } else if (quantity > 5 && quantity <= 10) {
        color = '#df8543'
    } else if (quantity > 10 && quantity <= 20) {
        color = '#ecce6d'
    } else if (quantity > 20 && quantity <= 50) {
        color = '#4dd599'
    } else if (quantity > 50) {
        color = '#3fc5f0'
    } else {
        color = '#262626'
    }
    return color
}

const shortNameByType = (type) => {
    let str
    switch (type) {
        case 1:
            str = 'MH'
            break;
        case 2:
            str = 'FH'
            break;
        case 3:
            str = 'CI'
            break;
        case 4:
            str = 'HI'
            break;
        case 5:
            str = 'HT'
            break;
        default:
            str = 'H'
            break;
    }
    return str;
}